import { render, staticRenderFns } from "./404.vue?vue&type=template&id=a2f2f5a4&scoped=true&lang=pug&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=a2f2f5a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f2f5a4",
  null
  
)

export default component.exports